import Vue from "vue";
import commonService from "@/common/api-services/common";
import configDirective from "@/common/directive/config-directive";
import homeDashboardService from "@/common/api-services/home-dashboard-service";

let vm = new Vue({});

let headers = {
    headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.VUE_APP_CONFIG_APIKEY,
    },
};
const initService = {
    showToast(msg, type = "b-toaster-top-full") {
        vm.$bvToast.toast(msg, {
            title: `Warning`,
            toaster: type,
            solid: true,
            appendToast: false,
        });
        //alert(msg);
    },

    getOpenCards() {
        let cards = sessionStorage.getItem("IOT_StoredCards");
        if (!cards) {
            this.resetOpenCards();
            cards = sessionStorage.getItem("IOT_StoredCards");
        }
        return cards;
    },

    setOpenCards(res) {
        sessionStorage.setItem("IOT_StoredCards", JSON.stringify(res));
    },

    resetOpenCards() {
        let openCards = {
            "dataVolume-map-collapse": true,
            "dataVolume-chart-collapse": true,
            "topMetrics-collapse": true,
            "sim-inventory-collapse": true,
            "watchdog-alerts-collapse": true,
        };
        this.setOpenCards(openCards);
    },

    getConfig() {
        return configDirective.getConfigData();
    },

    getApiVersion() {
        return homeDashboardService.getVersion();
    },

    getUxVersion() {
        return process.env.VUE_APP_VERSION;
    },

    getCustomerUser() {
        let userObj = JSON.parse(sessionStorage.getItem("IOT_GetCurrentUser"));
        //console.log('[USER OBJ]',userObj)
        return userObj;
    },

    getUserNameInfo() {
        if (this.getCustomerUser()) {
            return this.getCustomerUser().username;
        } else {
            return null;
        }
    },

    getGroups() {
        if (this.getCustomerUser()) {
            return this.getCustomerUser()["groups"];
        }
    },

    hasGroup(grp) {
        if (typeof grp === "undefined") return true;
        return this.getCustomerUser()["groups"].includes(grp);
    },

    getMenuLinks() {
        console.log('getMenuLinks')
        let links = [];
    },

    getPortalCarrier() {
        let carrier = "";
        if (this.getCustomerUser() && this.getCustomerUser()["groups"]) {
            //JSON.stringify(this.getCustomerUser()['groups']).includes('CARRIER_') ) {
            this.getCustomerUser()["groups"].forEach(val => {
                if (val.startsWith("CARRIER_")) {
                    carrier = val.replace("CARRIER_", "");
                }
            });
        }
       //console.log('USER_CARRIER from roles:',carrier);
        return carrier;
    },

    // this is admin status NOT readonly
    getEditorRole() {
        if (this.getCustomerUser()) {
            return this.getCustomerUser()["groups"].includes("Administrator");
        } else {
            return false;
        }
    },

    getPortalAdminRole() {
        let ret = false;
        if (this.getCustomerUser()) {
            ret = this.getCustomerUser().username === "iotadmin" || this.hasGroup("PORTAL_ADMIN") || this.hasGroup("DCC_DEVELOPER")
        } else {
            ret = false;
        }
        //console.log('hasPortalAdminRole:' + ret);
        return ret;
    },

    getReadOnlyRole() {
        let ret = false;
        if (this.getCustomerUser()) {
            if (
                this.getCustomerUser()["groups"].includes("readonly") ||
                this.getCustomerUser()["groups"].includes("read-only")
            ) {
                ret = true;
            } else {
                ret = false;
            }
        } else {
            ret = false;
        }
        //console.log('hasReadOnlyRole:' + ret);
        return ret;
    },

    getUserRoles() {
        if (this.getCustomerUser()) {
            let userObj = JSON.parse(sessionStorage.getItem("IOT_GetCurrentUser"));
            return userObj.groups;
        } else {
            return false;//JSON.parse('{"groups":["NONE"]}');
        }
    },

    getAdministratorRole() {
        let ret = false;
        if (this.getCustomerUser()) {
            ret = this.getCustomerUser()["groups"].includes("Administrator") || this.getCustomerUser()["groups"].includes("PORTAL_ADMIN");
        } else {
            ret = false;
        }
        //console.log('hasAdministratorRole:' + ret);
        return ret;
    },

    getCustomerInfo() {
        if (this.getCustomerUser()) {
            return this.getCustomerUser()["customer"] ? this.getCustomerUser()["customer"] : process.env.VUE_APP_CLIENT;
        } else {
            return process.env.VUE_APP_CLIENT;
        }
    },

    getCustomerEmailInfo() {
        if (this.getCustomerUser()) {
            return this.getCustomerUser().email;
        } else {
            return null;
        }
    },

    getNameInfo() {
        if (this.getPortalAdminRole()) return "DCC Portal Admin";
        else if (this.getCustomerUser() && !this.getCustomerUser().name || this.getCustomerUser().name === "") {
            return this.getCustomerUser().username;
        } else {
            return this.getCustomerUser().name;
        }
    },

    getGroupInfo() {
        if (this.getCustomerUser() && this.getCustomerUser()["groups"]) {
            return this.getCustomerUser()["groups"].join();
        } else {
            sessionStorage.clear();
            //sessionStorage.clear();
            return null;
        }
    },

    getAuthUserInfo() {
        let username, customer, group;
        let customerInfo = JSON.parse(sessionStorage.getItem("IOT_GetCurrentUser"));
        let userInfo = JSON.parse(sessionStorage.getItem("IOT_GetCurrentUser"));

        //if the userInfo is null you need to force logout.  This is a security check for the user in the system.
        if (userInfo === null || customerInfo === null) {
            username = null;
            customer = null;
            group = null;

            //send user to "login" or "unauthorized access" page.
            // this.$router.push({ name: 'Login' });
        } else {
            username = userInfo.username;
            customer = customerInfo["company_name"];
            group = customerInfo["customer_group"];
        }
        return {
            username,
            customer,
            group,
        };
    },

    getExpiryData() {
        let expiryData = sessionStorage.getItem("expiry");
        return JSON.parse(expiryData);
    },

    setConfig: function (res) {
        //this is aggressive to fix cache blockers
        // if (!res) {
        //   this.clearCache();
        //   return;
        // }
        sessionStorage.clear();
        sessionStorage.setItem("IOT_GetPortalConfig", JSON.stringify(res));
        let d = new Date();
        let e = d.getTime() + 15 * 6000; // Add 15 minutes
        sessionStorage.setItem("IOT_GetPortalConfig_expiry", e);
        commonService.startBugsnag();
    },

    clearCache() {
        sessionStorage.clear();
        //this.$router.go(0);
    },
};

export default initService;
